<template>
  <vs-popup class="user-edit-popup" id="popup" title="USER PASSWORD RESET" @close="open = false" :active.sync="open"
    :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickReset)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="password" name="password" rules="required" v-slot="{ errors }">
                <small class="label">New Password</small>
                <vx-input-group>
                  <vs-input v-model="form.password" name="password" class="w-full" label="" :danger="!!errors[0]"
                    :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                  <template slot="append">
                    <div style="cursor: pointer" class="prepend-text btn-addon flex">
                      <vx-tooltip text="Generate Strong Password" position="top">
                        <vs-button @click="onClickGenerate()" style="border-radius: 0" icon-pack="feather"
                          icon="icon-refresh-ccw" type="border" color="primary"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Copy Password" position="top">
                        <vs-button @click="onClickCopy(form.password)" style="border-radius: 0" icon-pack="feather"
                          icon="icon-copy" type="border" color="primary"></vs-button>
                      </vx-tooltip>

                    </div>
                  </template>
                </vx-input-group>

              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const UserRepository = RepositoryFactory.get('user')
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";

function initialState() {
  return {
    open: false,
    form: {
      password: ''
    },
    user: {},
  }
}

export default {
  name: 'ResetUserPasswordPopUp',
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods: {
    async openPopup(user) {
      try {
        await Object.assign(this.$data, initialState())
        this.open = true;
        this.user = user
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    onClickGenerate(length = 12) {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let password = '';

      for (let i = 0; i < length; i++) {
        password += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      this.form.password = password
    },
    onClickCopy(password) {
      navigator.clipboard.writeText(password)
      this.showSuccessMessage('Password copied to clipboard')
    },
    async onClickReset() {
      const vue = this;
      this.$vs.loading()
      try {
        await UserRepository.resetUserPassword(this.user.id, this.form)
        this.showSuccessMessage('User password reset successfully')
        await vue.$parent.refreshData()
        this.open = false;
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
  },
}
</script>

<style scoped>
.video-wrapper {
  width: 100%;
  height: 100%;
}

.video-wrapper video {
  object-fit: cover;
  width: 100%;
  height: 100%;

}

.image-wrapper {
  width: 100%;
  height: 75%;
}
</style>
